import { z } from "zod";

const PAGE_SIZE = 10;
export const statusSchema = z.enum([
  "ACTIVE",
  "INACTIVE",
  "EXPIRED",
  "SCHEDULED",
]);
export const sortBySchema = z.enum([
  "COMPANY",
  "TOTAL_PRICE",
  "MODULES",
  "CREATED_AT",
]);

export const subscriptionsSearchSchema = z
  .object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(PAGE_SIZE),
    sort: z.enum(["asc", "desc"]).optional(),
    sortBy: sortBySchema.optional(),
    search: z.string().trim().min(1).optional(),
    subscriberId: z.string().uuid().optional(),
    moduleId: z.string().uuid().optional(),
    activeOnly: z.coerce.boolean().optional(),
    status: statusSchema.optional(),
    fromCreatedAt: z.string().datetime().optional(),
    toCreatedAt: z.string().datetime().optional(),
  })
  .refine(
    (search) =>
      (search.fromCreatedAt === undefined) ===
      (search.toCreatedAt === undefined),
  );

export type SubscriptionsSearch = z.infer<typeof subscriptionsSearchSchema>;
export type SubscriptionSortBy = z.infer<typeof sortBySchema>;
export type SubscriptionStatus = z.infer<typeof statusSchema>;
